import { render, staticRenderFns } from "./FormValidationMultipleRules.vue?vue&type=template&id=53402712&"
import script from "./FormValidationMultipleRules.vue?vue&type=script&lang=js&"
export * from "./FormValidationMultipleRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports